import { render, staticRenderFns } from "./ToolbarAccountMenu.vue?vue&type=template&id=3d225cba&"
import script from "./ToolbarAccountMenu.vue?vue&type=script&lang=js&"
export * from "./ToolbarAccountMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports